import axios from 'axios';

import { getRuntimeConfigValue } from './runtimeConfig';

const API_URL = getRuntimeConfigValue('REACT_APP_API_URL') || 'http://localhost:8000/api';

export const api = axios.create({
  baseURL: API_URL,
});

export const authApi = axios.create({
  baseURL: `${API_URL}/auth`,
});
